export default {
  data () {
    return {
      editor: null,
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        excludeKeys: [
          'group-more-style',
          'fullScreen',
          'codeBlock',
          'insertTable',
          'insertVideo',
          'insertImage',
          'insertLink',
          'emotion',
          'todo',
          'fontFamily',
          '|',
          'undo',
          'redo',
          'blockquote'
        ],
      },
      editorConfig: {
        placeholder: '请输入内容（粘贴的内容默认自带格式，若不需要粘贴格式请选择『清除格式』）',
        // autoFocus: false,
        hoverbarKeys: {
          'text': {
            menuKeys: ['headerSelect', 'bulletedList', '|', 'bold', 'through', 'color', 'bgColor', 'clearStyle']
          },
          'image': {
            menuKeys: ['imageWidth30', 'imageWidth50', 'imageWidth100', 'deleteImage']
          }
        },
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            server: '/rest/info/rtf',
            fieldName: 'file',
            maxFileSize: 2 * 1024 * 1024, //2m
            allowedFileTypes: ['image/*'],
            // 最多可上传几个文件，默认为 100
            maxNumberOfFiles: 10,
            // 单个文件上传失败
            onFailed: (file, res) => {           // JS 语法
              // console.log(`${file.name} 上传失败`, res)
              this.$baseMessage(`${file.name} 上传失败`, 'error')
            },
            // 上传错误，或者触发 timeout 超时
            onError: (file, err, res) => {               // JS 语法
              // console.log(`${file.name} 上传出错`, err, res)
              this.$baseMessage(`${file.name} 上传出错，图片文件大小最大限制2M`, 'error')
            },
          },
          uploadVideo: {
            server: '/rest/info/rtf',
            fieldName: 'file',
            // 单个文件的最大体积限制，默认为 15M
            maxFileSize: 15 * 1024 * 1024, // 15M
            // 最多可上传几个文件，默认为 5
            maxNumberOfFiles: 3,
            // 选择文件时的类型限制，默认为 ['video/*'] 。如不想限制，则设置为 []
            allowedFileTypes: ['video/*'],
            // 单个文件上传失败
            onFailed: (file, res) => {           // JS 语法
              // console.log(`${file.name} 上传失败`, res)
              this.$baseMessage(`${file.name} 上传失败`, 'error')
            },
            // 上传错误，或者触发 timeout 超时
            onError: (file, err, res) => {               // JS 语法
              this.$baseMessage(`${file.name} 上传出错，视频文件大小最大限制15M`, 'error')
            },
          }
        }
      }
    }
  },
  created () {
  },
  mounted() {
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
    },
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  }
}
